module.exports = __webpack_public_path__ + "static/img/dana.9e39e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dana.png
// module id = HDEb
// module chunks = 1